import React from 'react'
import { Spin } from 'antd'

const LoadingScreen = function () {
  return (
    <div id='loading-wrapper'>
      <Spin size='large' />
    </div>
  )
}

export default LoadingScreen



// WEBPACK FOOTER //
// ./src/components/LoadingScreen.js